import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal, Spinner, Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import { get, post, put } from '../../../services/apiController';
import { toast } from 'react-toastify';

const AdsAddEditModal = ({ open, onClose, adId, callback }) => {
  const formFields = {
    title: '',
    status: '',
    fileType: '',
  };
  const [form, setForm] = useState(formFields);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    let _form = { ...form, [name]: value };
    setForm(_form);
  };
  const handleFileChange = (e) => {
    e.preventDefault();
    const { name } = e.target;
    setForm({ ...form, [name]: e.target.files[0] });
  };

  useMemo(() => {
    if (form.rentOrLeaseAmount && form.gstRate) {
      const withGstRentAmount = parseFloat(form.rentOrLeaseAmount) + parseFloat((form.rentOrLeaseAmount * form.gstRate) / 100);
      setForm({ ...form, withGstRentAmount });
    } else {
      setForm({ ...form, withGstRentAmount: form.rentOrLeaseAmount });
    }
  }, [form.rentOrLeaseAmount, form.gstRate]);

  const handleSubmit = () => {
    setLoading(true);
    const formData = new FormData();
    for (const key in form) {
      if (key === 'file') continue;
      formData.append(key, form[key]);
    }
    if (form.file !== null) formData.append('file', form['file']);
    if (adId) {
      put(formData, `/ks-ads/${adId}`, false)
        .then((res) => {
          toast.success(res?.data?.message);
          setForm(formFields);
          onClose();
          callback();
        })
        .catch((err) => toast.error(err?.response?.data?.data?.message || err?.message))
        .finally(() => setLoading(false));
    } else {
      post({ ...form }, '/ks-ads', false)
        .then((res) => {
          toast.success('Advertisement created successfully');
          setForm(formFields);
          onClose();
          callback();
        })
        .catch((err) => toast.error(err?.response?.data?.data?.message || err?.message))
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    if (adId) {
      get(`/ks-ads/${adId}`)
        .then((res) => {
          let form = { ...res.data };
          setForm(form);
          setLoading(false);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.data?.message || err.message);
          setLoading(false);
        });
    }
  }, [adId]);

  return (
    <Modal size="lg" show={open} backdrop="static" keyboard={false} className="request-modal">
      <Modal.Header>
        <Modal.Title>{adId ? 'Update Advertisement' : 'Create Advertisement'}</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
      </Modal.Header>
      <Modal.Body>
        <Form autoComplete="off">
          <Row>
            <Col xs={12}>
              <FloatingLabel label="Title" className="mb-3">
                <Form.Control
                  className="input"
                  name="title"
                  onChange={handleChange}
                  value={form.title}
                  type="text"
                  placeholder="Title"
                  required
                  autoComplete="false"
                />
              </FloatingLabel>
            </Col>
            <Col xs={12}>
              <FloatingLabel label="Status" className="mb-3">
                <select
                  required
                  name="status"
                  value={form.status}
                  onChange={handleChange}
                  aria-label="Floating label select example"
                  className="form-select"
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="inActive">inActive</option>
                </select>
              </FloatingLabel>
            </Col>
            <Col xs={12}>
              <FloatingLabel label="File Type" className="mb-3">
                <select
                  required
                  name="fileType"
                  value={form.fileType}
                  onChange={handleChange}
                  aria-label="Floating label select example"
                  className="form-select"
                >
                  <option value="">Select Type</option>
                  <option value="image">Image</option>
                  <option value="video">Video</option>
                </select>
              </FloatingLabel>
            </Col>
            <Col xs={12}>
              <Form.Label>File</Form.Label>
              <Form.Control className="input mb-3" name="file" onChange={handleFileChange} type="file" required autoComplete="false" accept='image/*,video/*'/>
            </Col>
          </Row>
          <div className="container text-center">
            {loading ? (
              <Button className="add-request-btn mt-4 mb-3 justify-content-center" variant="primary" disabled>
                <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                Loading...
              </Button>
            ) : (
              <Button type="submit" onClick={handleSubmit} className="add-request-btn mt-4 mb-3">
                {adId ? 'Update' : 'Submit'}
              </Button>
            )}
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AdsAddEditModal;
